import GROUP from 'src/api/dev/componentGroup'
import * as T from './types'

const module = {
    state: {
        total: 0,
        groupList: [],
        itemMap: {},
        currentId: '',
        lastResponse: {}
    },
    mutations: {
        [T.SET_LAST_RESPONSE](state, { code, msg }) {
            state.lastResponse = { code, msg } // 尝试避免 actions 返回数据，将请求结果放到state中
        },
        [T.CLEAR_LAST_RESPONSE](state) {
            state.lastResponse = {}
        },
        [T.SET_GROUP_LIST](state, { items, total }) {
            state.groupList = items
            state.total = total
        },
        [T.SET_GROUP_DETAIL](state, data) {
            state.itemMap[data.id] = data
            state.currentId = data.id
        },
        [T.PICK_ITEM](state, item) {
            state.itemMap[item.id] = item
            state.currentId = item.id
        },
        [T.DELETE_GROUP_ITEM](state, id) {
            delete state.itemMap[id]
            state.groupList = state.groupList.filter(item => item.id !== id)
            // 只删除1个
            state.total -= 1
        },
        // 分组详情更新
        [T.UPDATE_GROUP_ITEM](state, item) {
            // 如果API成功，更新vuex中的数据。使用解构的方式创建新的obj
            const d = new Date()
            /*eslint no-mixed-operators: "off"*/
            item.modified_on = new Date(+d - d.getTimezoneOffset() * 60 * 1000)
                .toISOString()
                .replace('T', ' ')
                .substr(0, 19)
            state.itemMap[item.id] = { ...item }
            const index = state.groupList.findIndex(({ id }) => id === item.id)
            if (index > -1) {
                state.groupList.splice(index, 1, { ...item })
            }
        },
        [T.CLEAR_GROUP_DATA](state) {
            state.total = 0
            state.groupList.splice(0, Infinity)
        }
    },
    actions: {
        pickItem({ commit }, item) {
            commit(T.PICK_ITEM, item)
        },
        // 这里现在默认都是取得全量数据。前端做分页
        // 如果后面改成分页获取，会影响到 应用详情 的 引用组件 页面
        async getGroupList({ state, commit }, { force, ...params } = {}) {
            if (force || !state.groupList.length) {
                commit(T.SET_GROUP_LIST, await GROUP.list(params))
            }
        },
        async getGroupDetail({ commit }, id) {
            commit(T.SET_GROUP_DETAIL, await GROUP.detail(id))
        },
        async updateGroupItem({ commit }, payload) {
            await GROUP.update(payload)
            commit(T.UPDATE_GROUP_ITEM, payload)
        },
        async addGroupItem({ dispatch }, payload) {
            await dispatch('setLastResponse', await GROUP.add(payload))
        },
        setLastResponse({ commit }, lastResponse) {
            return new Promise(resolve => {
                commit(T.SET_LAST_RESPONSE, lastResponse)
                resolve(lastResponse)
            })
        },
        async deleteGroupItem({ commit }, id) {
            await GROUP.delete(id)
            commit(T.DELETE_GROUP_ITEM, id)
        },
        clearGroupData({ commit }) {
            commit(T.CLEAR_GROUP_DATA)
        }
    },
    getters: {
        allGroups: state => state.groupList,
        groupListFn: state => (pageSize = 10) => state.groupList.slice(0, pageSize)
    }
}

export default module
